var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x32_5_attachment"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_4_office"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.5273,34.4512h22.5313c0.5527,0,1-0.4478,1-1v-6.1519c0-0.5522-0.4473-1-1-1H31.5273c-0.5527,0-1,0.4478-1,1v6.1519     C30.5273,34.0034,30.9746,34.4512,31.5273,34.4512z M47.5479,28.2993h5.5107v4.1519h-5.5107V28.2993z M40.0381,28.2993h5.5098     v4.1519h-5.5098V28.2993z M32.5273,28.2993h5.5107v4.1519h-5.5107V28.2993z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,60.8833h-1.125V11.1647c1.1713-0.2427,2.0547-1.2807,2.0547-2.5216V7.3232c0-1.4204-1.1572-2.5757-2.5791-2.5757     H25.2354c-1.4209,0-2.5762,1.1553-2.5762,2.5757v1.3198c0,0.1985,0.0275,0.3899,0.0702,0.5757H11.792V5.5513     c0-0.5522-0.4473-1-1-1s-1,0.4478-1,1v3.6675H6.5361V2.1167c0-0.5522-0.4473-1-1-1s-1,0.4478-1,1v7.1021H3.2119     C1.9922,9.2188,1,10.2124,1,11.4341v2.8887c0,1.2192,0.9922,2.2114,2.2119,2.2114h0.1904v44.3491H2c-0.5527,0-1,0.4478-1,1     s0.4473,1,1,1h60c0.5527,0,1-0.4478,1-1S62.5527,60.8833,62,60.8833z M11.9395,60.8833v-9.8662h5.9795v9.8662H11.9395z      M24.7119,60.8833h-4.793V50.0171c0-0.5522-0.4473-1-1-1h-7.9795c-0.5527,0-1,0.4478-1,1v10.8662H5.4023V16.5342h19.3096V60.8833     z M4.4023,14.5342H3.2119C3.0986,14.5342,3,14.4355,3,14.3228v-2.8887c0-0.1167,0.0967-0.2153,0.2119-0.2153h21.5v3.3154H4.4023z      M41.7949,60.8833h-4.2393v-9.8662h4.2393V60.8833z M48.0313,60.8833h-4.2363v-9.8662h4.2363V60.8833z M58.875,60.8833h-8.8438     V50.0171c0-0.5522-0.4473-1-1-1H36.5557c-0.5527,0-1,0.4478-1,1v10.8662h-8.8438V11.2188H58.875V60.8833z M60.3506,9.2188H59.875     H25.7119h-0.4766c-0.3174,0-0.5762-0.2583-0.5762-0.5757V7.3232c0-0.312,0.2637-0.5757,0.5762-0.5757h35.1152     c0.3135,0,0.5791,0.2637,0.5791,0.5757v1.3198C60.9297,8.9604,60.6699,9.2188,60.3506,9.2188z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8926,29.1709h10.2031c0.5527,0,1-0.4478,1-1v-6.2256c0-0.5522-0.4473-1-1-1H9.8926c-0.5527,0-1,0.4478-1,1v6.2256     C8.8926,28.7231,9.3398,29.1709,9.8926,29.1709z M15.9941,22.9453h3.1016v4.2256h-3.1016V22.9453z M10.8926,22.9453h3.1016     v4.2256h-3.1016V22.9453z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8926,41.6436h10.2031c0.5527,0,1-0.4478,1-1v-6.2295c0-0.5522-0.4473-1-1-1H9.8926c-0.5527,0-1,0.4478-1,1v6.2295     C8.8926,41.1958,9.3398,41.6436,9.8926,41.6436z M15.9941,35.4141h3.1016v4.2295h-3.1016V35.4141z M10.8926,35.4141h3.1016     v4.2295h-3.1016V35.4141z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5273,45.4775h22.5313c0.5527,0,1-0.4478,1-1v-6.1519c0-0.5522-0.4473-1-1-1H31.5273c-0.5527,0-1,0.4478-1,1v6.1519     C30.5273,45.0298,30.9746,45.4775,31.5273,45.4775z M47.5479,39.3257h5.5107v4.1519h-5.5107V39.3257z M40.0381,39.3257h5.5098     v4.1519h-5.5098V39.3257z M32.5273,39.3257h5.5107v4.1519h-5.5107V39.3257z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5273,23.4287h22.5313c0.5527,0,1-0.4478,1-1v-6.1523c0-0.5522-0.4473-1-1-1H31.5273c-0.5527,0-1,0.4478-1,1v6.1523     C30.5273,22.981,30.9746,23.4287,31.5273,23.4287z M47.5479,17.2764h5.5107v4.1523h-5.5107V17.2764z M40.0381,17.2764h5.5098     v4.1523h-5.5098V17.2764z M32.5273,17.2764h5.5107v4.1523h-5.5107V17.2764z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_3_pin"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_2_business_card"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_1_form"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_0_headset"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_9_video_call"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_8_letter_box"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_7_papperplane"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_6_laptop"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_5_connection"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_4_phonebook"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_3_classic_telephone"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_2_sending_mail"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_1_man_talking"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_0_date"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "_x30_9_review"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "_x30_8_email"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "_x30_7_information"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "_x30_6_phone_talking"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "_x30_5_women_talking"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "_x30_4_calling"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "_x30_3_women"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_writing"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_chatting"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.34420193ec74eab204a9886ef810a698.svg";
export { ForwardRef as ReactComponent };